import * as api from '../apiCallerProxy';
import { operationsApiFactory } from './operationsApiFactory';

export * from './hooks';
export default operationsApiFactory(api);
